/* eslint-disable */

import isPlainObject from './isPlainObject';

/**
 * Recursively merges a source object into a target object
 */
export default function extend<T, U>(this: any, target: T, source: U): T & U {
  // As inspired from JQuery extend
  let options;
  let name;
  let src;
  let copy;
  let copyIsArray;
  let clone;
  target = target || ({} as T);

  // Handle case when target is a string or something
  if (typeof target !== 'object' && !(typeof target === 'function')) {
    target = ({} as T);
  }

  // Only deal with non-null/undefined values
  if ((options = source) != null) {
    // Extend the base object
    for (name in options) {
      src = (target as any)[name];
      copy = (options as any)[name];

      // Prevent never-ending loop
      if (target === copy) {
        continue;
      }

      // Recurse if we're merging plain objects or arrays
      if (copy && (isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
        if (copyIsArray) {
          copyIsArray = false;
          clone = src && Array.isArray(src) ? src : [];
        } else {
          clone = src && isPlainObject(src) ? src : {};
        }

        // Never move original objects, clone them
        (target as any)[name] = extend(clone, copy);

        // Don't bring in undefined values
      } else if (copy !== undefined) {
        (target as any)[name] = copy;
      }
    }
  }

  // Return the modified object
  return (target as T & U);
}
